module.exports = __webpack_public_path__ + "public/files/img/file.4a0c1c0e.png";